import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, ShoppingCart } from "lucide-react";
import { Button } from "../components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Loader } from "../components/common";
import { DocSheet } from "../components/DocSheet";
import { DocToolbar, useDocParams } from "../components/DocToolbar";
import { useApi } from "../hooks/useApi";
import { api, formatApiError, dateTimeFmt, PAYMENT_METHODS } from "../lib/api";

function ConvertControl({ id }) {
  const navigate = useNavigate();
  const [payment, setPayment] = useState("Cash");
  const [busy, setBusy] = useState(false);
  const convert = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/quotations/${id}/convert`, { payment_method: payment });
      toast.success(`Converted to sale ${data.receipt_no}`);
      navigate(`/sales/${data.id}`);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="flex items-center gap-2">
      <Select value={payment} onValueChange={setPayment}>
        <SelectTrigger className="h-10 w-[150px] bg-slate-900" data-testid="convert-payment-select"><SelectValue /></SelectTrigger>
        <SelectContent>{PAYMENT_METHODS.map((m) => <SelectItem key={m} value={m}>{m}</SelectItem>)}</SelectContent>
      </Select>
      <Button onClick={convert} disabled={busy} className="bg-emerald-600 hover:bg-emerald-500 text-white" data-testid="convert-to-sale-button">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <ShoppingCart className="h-4 w-4" />} Convert to sale
      </Button>
    </div>
  );
}

export default function QuotationDoc() {
  const { id } = useDocParams();
  const { data: q } = useApi(`/quotations/${id}`);
  if (!q) return <Loader />;
  return (
    <div className="space-y-6">
      <DocToolbar title={`Quotation ${q.quote_no}`} pdfPath={`/quotations/${id}/pdf`} filename={`quotation-${q.quote_no}.pdf`} allowThermal={false} thermal={false}
        extra={q.status === "open" ? <ConvertControl id={id} /> : <span className="text-sm text-emerald-400" data-testid="quotation-converted-label">Converted · {q.receipt_no}</span>} />
      <DocSheet kind="QUOTATION" number={q.quote_no} items={q.items} total={q.total}
        meta={[["Date", dateTimeFmt(q.created_at)], ["Depot", q.depot_name], ["Customer", q.customer], ["Phone", q.customer_phone], ["Valid until", q.valid_until], ["Prepared by", q.user_name], ["Note", q.note]]}
        footer={["Prices include VAT at 18%.", "Prices are subject to stock availability at the time of purchase.", "Authorised signature: ______________________"]} />
    </div>
  );
}
